import { Viewport } from '@xyflow/react'
import { useState, useEffect } from 'react'
import useUserLocalSettingsStore from '~/stores/userLocalSettingsStore'

export function useViewportSettings(projectId: string) {
  const [isLoaded, setIsLoaded] = useState(false)

  const { viewportSettings, setViewportSettings } = useUserLocalSettingsStore(
    (state) => ({
      viewportSettings: state.viewportSettings,
      setViewportSettings: state.setViewportSettings,
    })
  )

  // Load viewport settings from localStorage on the client side when initializing first time
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const key = `viewportSettings_${projectId}`
      const settings = window.localStorage.getItem(key)
      if (settings) {
        setViewportSettings(JSON.parse(settings))
      }
      setIsLoaded(true)
    }
  }, [projectId, setViewportSettings])

  // Synchronize with localStorage in useEffect
  useEffect(() => {
    if (typeof window !== 'undefined' && isLoaded) {
      const key = `viewportSettings_${projectId}`
      window.localStorage.setItem(key, JSON.stringify(viewportSettings))
    }
  }, [viewportSettings, isLoaded, projectId])

  const initializeViewport = (instance: any) => {
    if (typeof window !== 'undefined') {
      const key = `viewportSettings_${projectId}`
      const savedSettings = window.localStorage.getItem(key)
      if (savedSettings) {
        const parsedSettings = JSON.parse(savedSettings)
        instance.setViewport(parsedSettings)
      } else {
        instance.setViewport(viewportSettings)
      }
    } else {
      instance.setViewport(viewportSettings)
    }
  }

  return {
    viewportSettings,
    setViewportSettings,
    initializeViewport,
    isLoaded,
  }
}
